import type { BlockingTranslation } from './types';

export const blockingHi: BlockingTranslation = {
  menuItem: 'विज़िटर को ब्लॉक करें…',
  menuItemSender: 'भेजने वाले को ब्लॉक करें…',
  action: 'ब्लॉक करें',
  actionFor: '{{name}} को ब्लॉक करें',
  dialog: {
    title: '{{name}} को ब्लॉक करें',
    explanation:
      'उन्हें बस यह दिखेगा कि चैट अभी उपलब्ध नहीं है। ब्राउज़र का डेटा मिटाने से ब्लॉक हट जाता है; साइन-इन किए ग्राहक हर डिवाइस पर ब्लॉक रहते हैं।',
    reason: 'कारण',
    reasonHint: 'यह सिर्फ़ आपकी टीम को, ब्लॉक किए गए पेज पर दिखता है।',
    reasonMissing: 'लिखें कि आप उन्हें क्यों ब्लॉक कर रहे हैं।',
    duration: 'कितने समय के लिए',
    closeChat: 'यह चैट भी बंद करें',
    submit: 'विज़िटर को ब्लॉक करें',
    done: '{{name}} ब्लॉक हो गए।',
    doneClosed: '{{name}} ब्लॉक हो गए, और चैट बंद हो गई।',
    /** A sender on email, WhatsApp or Telegram. */
    sender: {
      explanation:
        'उनके संदेश आते रहेंगे, पर हर बातचीत बिना जवाब के अपने-आप बंद हो जाएगी। उन्हें बताया नहीं जाता। ब्लॉक सिर्फ़ इस चैनल पर इसी पते पर लागू होता है।',
      closeChat: 'यह बातचीत भी बंद करें',
      submit: 'भेजने वाले को ब्लॉक करें',
      doneClosed: '{{name}} ब्लॉक हो गए, और बातचीत बंद हो गई।',
    },
  },
  durations: {
    day: '24 घंटे',
    week: '7 दिन',
    month: '30 दिन',
    always: 'अनब्लॉक होने तक',
  },
  durationHints: {
    until: '{{time}} तक',
    never: 'जब तक आपकी टीम का कोई उन्हें अनब्लॉक न करे',
  },
  page: {
    link: 'ब्लॉक किए गए',
    /** An anonymous visitor, by the short code that tells them apart. */
    anonymous: 'विज़िटर {{code}}',
    /** After a sender's address, which comes first in every language: "amina@… on Email". */
    senderOn: '{{channel}} पर',
    /** A sender with no address (Telegram). */
    senderNoAddress: '{{channel}} पर भेजने वाले',
    title: 'ब्लॉक किए गए विज़िटर',
    description:
      'जो विज़िटर आपके ब्रांड से चैट नहीं कर सकते, उन्हें क्यों और कब तक ब्लॉक किया गया है। यहाँ अनब्लॉक करें, तो वे तुरंत फिर चैट कर सकते हैं।',
    guide: 'ब्लॉक करना कैसे काम करता है',
    back: 'इनबॉक्स पर वापस जाएँ',
    loading: 'ब्लॉक किए गए विज़िटर लोड हो रहे हैं',
    table: 'ब्लॉक किए गए विज़िटर, नए पहले',
    show: 'दिखाएँ',
    filters: {
      active: 'चालू',
      all: 'सभी (पिछले 90 दिन)',
    },
    brand: 'ब्रांड',
    allBrands: 'सभी ब्रांड',
    columns: {
      who: 'कौन',
      reason: 'कारण',
      by: 'किसने ब्लॉक किया',
      when: 'कब',
      expires: 'समाप्ति',
      actions: 'कार्रवाइयाँ',
    },
    signedIn: 'साइन इन',
    formerStaff: 'कोई जो अब टीम में नहीं है',
    standing: {
      never: 'अनब्लॉक होने तक',
      lifted: '{{time}} अनब्लॉक हुआ',
      liftedBy: '{{name}} ने अनब्लॉक किया, {{time}}',
      expired: '{{time}} समाप्त हुआ',
    },
    openChat: 'चैट खोलें',
    openChatFor: '{{name}} के साथ चैट खोलें',
    unblock: 'अनब्लॉक करें',
    unblockFor: '{{name}} को अनब्लॉक करें',
    confirm: {
      title: '{{name}} को अनब्लॉक करें?',
      body: 'वे तुरंत फिर से चैट शुरू कर सकते हैं। ब्लॉक यहाँ सूची में रहता है, अनब्लॉक के निशान के साथ।',
      submit: 'अनब्लॉक करें',
      done: '{{name}} अनब्लॉक हो गए।',
      failed: '{{name}} अभी भी ब्लॉक हैं।',
    },
    empty: {
      title: 'कोई ब्लॉक नहीं है',
      description:
        'जब कोई चैट का गलत इस्तेमाल करे, तो उसे चैट के "और कार्रवाइयाँ" मेन्यू से या लाइव विज़िटर से ब्लॉक करें।',
      allTitle: 'पिछले 90 दिनों में कोई ब्लॉक नहीं',
    },
    forbidden: {
      title: 'आप ब्लॉक किए गए विज़िटर नहीं देख सकते',
      description: 'आपकी भूमिका विज़िटर को ब्लॉक या अनब्लॉक नहीं कर सकती। किसी एडमिन या सुपरवाइज़र से कहें।',
    },
  },
};
